module.exports = __webpack_public_path__ + "img/gb.3176334.svg";